import { Getters } from 'vuex-smart-module';
import FilesState from './state';

export default class FilesGetters extends Getters<FilesState> {
  get files() {
    return this.state.files;
  }

  get totalItems() {
    return this.state.pagination_props.total_items;
  }

  get tableOptions() {
    return this.state.table_options;
  }

  get loading() {
    return this.state.loading;
  }
}
